// Vietnamese Administrative Divisions & Smart Address Parser
// Dành cho tính cước bưu cục Best Express và định danh địa chỉ bưu điện chuẩn xác

export interface DistrictInfo {
  name: string
  wards: string[]
}

export interface ProvinceInfo {
  name: string
  aliases?: string[]
  districts: Record<string, string[]>
}

export const VIETNAM_PROVINCES: Record<string, ProvinceInfo> = {
  "Hồ Chí Minh": {
    name: "Hồ Chí Minh",
    aliases: ["TP.HCM", "TPHCM", "Sài Gòn", "Saigon", "TP Hồ Chí Minh", "Thành phố Hồ Chí Minh"],
    districts: {
      "Quận 1": [
        "Phường Bến Nghé", "Phường Bến Thành", "Phường Cầu Kho", "Phường Cầu Ông Lãnh",
        "Phường Cô Giang", "Phường Đa Kao", "Phường Nguyễn Cư Trinh", "Phường Nguyễn Thái Bình",
        "Phường Phạm Ngũ Lão", "Phường Tân Định"
      ],
      "Quận 3": [
        "Phường 1", "Phường 2", "Phường 3", "Phường 4", "Phường 5", "Phường 9", "Phường 10",
        "Phường 11", "Phường 12", "Phường 13", "Phường 14", "Phường Võ Thị Sáu"
      ],
      "Quận 4": ["Phường 1", "Phường 2", "Phường 3", "Phường 4", "Phường 6", "Phường 8", "Phường 9", "Phường 10", "Phường 13", "Phường 14", "Phường 15", "Phường 16", "Phường 18"],
      "Quận 5": ["Phường 1", "Phường 2", "Phường 3", "Phường 4", "Phường 5", "Phường 6", "Phường 7", "Phường 8", "Phường 9", "Phường 10", "Phường 11", "Phường 12", "Phường 13", "Phường 14"],
      "Quận 6": ["Phường 1", "Phường 2", "Phường 3", "Phường 4", "Phường 5", "Phường 6", "Phường 7", "Phường 8", "Phường 9", "Phường 10", "Phường 11", "Phường 12", "Phường 13", "Phường 14"],
      "Quận 7": ["Phường Tân Thuận Đông", "Phường Tân Thuận Tây", "Phường Tân Kiểng", "Phường Tân Hưng", "Phường Bình Thuận", "Phường Tân Quy", "Phường Phú Thuận", "Phường Tân Phú", "Phường Tân Phong", "Phường Phú Mỹ"],
      "Quận 8": ["Phường 1", "Phường 2", "Phường 3", "Phường 4", "Phường 5", "Phường 6", "Phường 7", "Phường 8", "Phường 9", "Phường 10", "Phường 11", "Phường 12", "Phường 13", "Phường 14", "Phường 15", "Phường 16"],
      "Quận 10": ["Phường 1", "Phường 2", "Phường 4", "Phường 5", "Phường 6", "Phường 7", "Phường 8", "Phường 9", "Phường 10", "Phường 11", "Phường 12", "Phường 13", "Phường 14", "Phường 15"],
      "Quận 11": ["Phường 1", "Phường 2", "Phường 3", "Phường 4", "Phường 5", "Phường 6", "Phường 7", "Phường 8", "Phường 9", "Phường 10", "Phường 11", "Phường 12", "Phường 13", "Phường 14", "Phường 15", "Phường 16"],
      "Quận 12": ["Phường Thạnh Xuân", "Phường Thạnh Lộc", "Phường Hiệp Thành", "Phường Thới An", "Phường Tân Chánh Hiệp", "Phường An Phú Đông", "Phường Tân Thới Hiệp", "Phường Trung Mỹ Tây", "Phường Tân Hưng Thuận", "Phường Đông Hưng Thuận", "Phường Tân Thới Nhất"],
      "Bình Thạnh": ["Phường 1", "Phường 2", "Phường 3", "Phường 5", "Phường 6", "Phường 7", "Phường 11", "Phường 12", "Phường 13", "Phường 14", "Phường 15", "Phường 17", "Phường 19", "Phường 21", "Phường 22", "Phường 24", "Phường 25", "Phường 26", "Phường 27", "Phường 28"],
      "Gò Vấp": ["Phường 1", "Phường 3", "Phường 4", "Phường 5", "Phường 6", "Phường 7", "Phường 8", "Phường 9", "Phường 10", "Phường 11", "Phường 12", "Phường 13", "Phường 14", "Phường 15", "Phường 16", "Phường 17"],
      "Phú Nhuận": ["Phường 1", "Phường 2", "Phường 3", "Phường 4", "Phường 5", "Phường 7", "Phường 8", "Phường 9", "Phường 10", "Phường 11", "Phường 13", "Phường 15", "Phường 17"],
      "Tân Bình": ["Phường 1", "Phường 2", "Phường 3", "Phường 4", "Phường 5", "Phường 6", "Phường 7", "Phường 8", "Phường 9", "Phường 10", "Phường 11", "Phường 12", "Phường 13", "Phường 14", "Phường 15"],
      "Tân Phú": ["Phường Tân Sơn Nhì", "Phường Tây Thạnh", "Phường Sơn Kỳ", "Phường Tân Quý", "Phường Tân Thành", "Phường Phú Thọ Hòa", "Phường Phú Thạnh", "Phường Phú Trung", "Phường Hòa Thạnh", "Phường Hiệp Tân", "Phường Tân Thới Hòa"],
      "Bình Tân": ["Phường Bình Hưng Hòa", "Phường Bình Hưng Hòa A", "Phường Bình Hưng Hòa B", "Phường Bình Trị Đông", "Phường Bình Trị Đông A", "Phường Bình Trị Đông B", "Phường Tân Tạo", "Phường Tân Tạo A", "Phường An Lạc", "Phường An Lạc A"],
      "TP Thủ Đức": [
        "Phường Linh Trung", "Phường Linh Tây", "Phường Linh Chiểu", "Phường Linh Đông", "Phường Tam Bình",
        "Phường Tam Phú", "Phường Hiệp Bình Chánh", "Phường Hiệp Bình Phước", "Phường Thảo Điền", "Phường An Phú",
        "Phường Bình An", "Phường Bình Trưng Đông", "Phường Bình Trưng Tây", "Phường Thạnh Mỹ Lợi", "Phường Cát Lái",
        "Phường Tăng Nhơn Phú A", "Phường Tăng Nhơn Phú B", "Phường Phước Long A", "Phường Phước Long B", "Phường Long Trường",
        "Phường Trường Thạnh", "Phường Long Thạnh Mỹ", "Phường Hiệp Phú", "Phường Tân Phú"
      ],
      "Bình Chánh": ["Thị trấn Tân Túc", "Xã An Phú Tây", "Xã Bình Chánh", "Xã Bình Hưng", "Xã Bình Lợi", "Xã Đa Phước", "Xã Hưng Long", "Xã Lê Minh Xuân", "Xã Phạm Văn Hai", "Xã Phong Phú", "Xã Quy Đức", "Xã Tân Kiên", "Xã Tân Nhựt", "Xã Tân Quý Tây", "Xã Vĩnh Lộc A", "Xã Vĩnh Lộc B"],
      "Hóc Môn": ["Thị trấn Hóc Môn", "Xã Bà Điểm", "Xã Đông Thạnh", "Xã Nhị Bình", "Xã Tân Hiệp", "Xã Tân Thới Nhì", "Xã Tân Xuân", "Xã Thới Tam Thôn", "Xã Trung Chánh", "Xã Xuân Thới Đông", "Xã Xuân Thới Sơn", "Xã Xuân Thới Thượng"],
      "Củ Chi": ["Thị trấn Củ Chi", "Xã An Nhơn Tây", "Xã An Phú", "Xã Bình Mỹ", "Xã Hòa Phú", "Xã Nhuận Đức", "Xã Phạm Văn Cội", "Xã Phú Hòa Đông", "Xã Tân An Hội", "Xã Tân Thạnh Đông", "Xã Tân Thông Hội"],
      "Nhà Bè": ["Thị trấn Nhà Bè", "Xã Hiệp Phước", "Xã Long Thới", "Xã Nhơn Đức", "Xã Phú Xuân", "Xã Phước Kiển", "Xã Phước Lộc"],
      "Cần Giờ": ["Thị trấn Cần Thạnh", "Xã An Thới Đông", "Xã Bình Khánh", "Xã Long Hòa", "Xã Lý Nhơn", "Xã Tam Thôn Hiệp", "Xã Thạnh An"]
    }
  },
  "Hà Nội": {
    name: "Hà Nội",
    aliases: ["HN", "Ha Noi", "Thủ đô Hà Nội", "TP Hà Nội"],
    districts: {
      "Ba Đình": ["Phường Cống Vị", "Phường Điện Biên", "Phường Đội Cấn", "Phường Giảng Võ", "Phường Kim Mã", "Phường Liễu Giai", "Phường Ngọc Hà", "Phường Ngọc Khánh", "Phường Nguyễn Trung Trực", "Phường Phúc Xá", "Phường Quán Thánh", "Phường Thành Công", "Phường Trúc Bạch", "Phường Vĩnh Phúc"],
      "Hoàn Kiếm": ["Phường Chương Dương", "Phường Cửa Đông", "Phường Cửa Nam", "Phường Đồng Xuân", "Phường Hàng Bạc", "Phường Hàng Bài", "Phường Hàng Bồ", "Phường Hàng Bông", "Phường Hàng Buồm", "Phường Hàng Đào", "Phường Hàng Gai", "Phường Hàng Mã", "Phường Hàng Trống", "Phường Lý Thái Tổ", "Phường Phan Chu Trinh", "Phường Phúc Tân", "Phường Tràng Tiền", "Phường Trần Hưng Đạo"],
      "Đống Đa": ["Phường Cát Linh", "Phường Hàng Bột", "Phường Khâm Thiên", "Phường Khương Thượng", "Phường Kim Liên", "Phường Láng Hạ", "Phường Láng Thượng", "Phường Nam Đồng", "Phường Ngã Tư Sở", "Phường Ô Chợ Dừa", "Phường Phương Liên", "Phường Phương Mai", "Phường Quang Trung", "Phường Quốc Tử Giám", "Phường Thịnh Quang", "Phường Thổ Quan", "Phường Trung Liệt", "Phường Trung Phụng", "Phường Trung Tự", "Phường Văn Chương", "Phường Văn Miếu"],
      "Hai Bà Trưng": ["Phường Bách Khoa", "Phường Bạch Đằng", "Phường Bạch Mai", "Phường Cầu Dền", "Phường Đống Mác", "Phường Đồng Nhân", "Phường Đồng Tâm", "Phường Lê Đại Hành", "Phường Minh Khai", "Phường Nguyễn Du", "Phường Phạm Đình Hổ", "Phường Phố Huế", "Phường Quỳnh Lôi", "Phường Quỳnh Mai", "Phường Thanh Lương", "Phường Thanh Nhàn", "Phường Trương Định", "Phường Vĩnh Tuy"],
      "Cầu Giấy": ["Phường Dịch Vọng", "Phường Dịch Vọng Hậu", "Phường Mai Dịch", "Phường Nghĩa Đô", "Phường Nghĩa Tân", "Phường Quan Hoa", "Phường Trung Hòa", "Phường Yên Hòa"],
      "Thanh Xuân": ["Phường Hạ Đình", "Phường Khương Đình", "Phường Khương Mai", "Phường Khương Trung", "Phường Kim Giang", "Phường Nhân Chính", "Phường Phương Liệt", "Phường Thanh Xuân Bắc", "Phường Thanh Xuân Nam", "Phường Thanh Xuân Trung", "Phường Thượng Đình"],
      "Tây Hồ": ["Phường Bưởi", "Phường Nhật Tân", "Phường Phú Thượng", "Phường Quảng An", "Phường Thụy Khuê", "Phường Tứ Liên", "Phường Xuân La", "Phường Yên Phụ"],
      "Hoàng Mai": ["Phường Đại Kim", "Phường Định Công", "Phường Giáp Bát", "Phường Hoàng Liệt", "Phường Hoàng Văn Thụ", "Phường Lĩnh Nam", "Phường Mai Động", "Phường Tân Mai", "Phường Thanh Trì", "Phường Thịnh Liệt", "Phường Trần Phú", "Phường Tương Mai", "Phường Vĩnh Hưng", "Phường Yên Sở"],
      "Long Biên": ["Phường Bồ Đề", "Phường Cự Khối", "Phường Đức Giang", "Phường Gia Thụy", "Phường Giang Biên", "Phường Long Biên", "Phường Ngọc Lâm", "Phường Ngọc Thụy", "Phường Phúc Đồng", "Phường Phúc Lợi", "Phường Sài Đồng", "Phường Thạch Bàn", "Phường Thượng Thanh", "Phường Việt Hưng"],
      "Nam Từ Liêm": ["Phường Cầu Diễn", "Phường Đại Mỗ", "Phường Mễ Trì", "Phường Mỹ Đình 1", "Phường Mỹ Đình 2", "Phường Phú Đô", "Phường Phương Canh", "Phường Tây Mỗ", "Phường Trung Văn", "Phường Xuân Phương"],
      "Bắc Từ Liêm": ["Phường Cổ Nhuế 1", "Phường Cổ Nhuế 2", "Phường Đông Ngạc", "Phường Đức Thắng", "Phường Liên Mạc", "Phường Minh Khai", "Phường Phú Diễn", "Phường Phúc Diễn", "Phường Tây Tựu", "Phường Thượng Cát", "Phường Thụy Phương", "Phường Xuân Đỉnh", "Phường Xuân Tảo"],
      "Hà Đông": ["Phường Biên Giang", "Phường Đồng Mai", "Phường Dương Nội", "Phường Hà Cầu", "Phường Kiến Hưng", "Phường La Khê", "Phường Mộ Lao", "Phường Nguyễn Trãi", "Phường Phú La", "Phường Phú Lãm", "Phường Phú Lương", "Phường Phúc La", "Phường Quang Trung", "Phường Vạn Phúc", "Phường Văn Quán", "Phường Yên Nghĩa", "Phường Yết Kiêu"],
      "Gia Lâm": ["Thị trấn Trâu Quỳ", "Thị trấn Yên Viên", "Xã Bát Tràng", "Xã Cổ Bi", "Xã Đa Tốn", "Xã Đặng Xá", "Xã Đình Xuyên", "Xã Đông Dư", "Xã Dương Hà", "Xã Dương Quang", "Xã Dương Xá", "Xã Kiêu Kỵ", "Xã Ninh Hiệp", "Xã Phù Đổng", "Xã Phú Thị"],
      "Đông Anh": ["Thị trấn Đông Anh", "Xã Bắc Hồng", "Xã Cổ Loa", "Xã Dục Tú", "Xã Hải Bối", "Xã Kim Chung", "Xã Kim Nỗ", "Xã Mai Lâm", "Xã Nam Hồng", "Xã Nguyên Khê", "Xã Tàm Xá", "Xã Thụy Lâm", "Xã Tiên Dương", "Xã Uy Nỗ", "Xã Vân Hà", "Xã Vân Nội", "Xã Vĩnh Ngọc", "Xã Võng La", "Xã Xuân Canh", "Xã Xuân Nộn"],
      "Thanh Trì": ["Thị trấn Văn Điển", "Xã Đại Áng", "Xã Đông Mỹ", "Xã Duyên Hà", "Xã Hữu Hòa", "Xã Liên Ninh", "Xã Ngọc Hồi", "Xã Ngũ Hiệp", "Xã Tả Thanh Oai", "Xã Tam Hiệp", "Xã Tân Triều", "Xã Thanh Liệt", "Xã Tứ Hiệp", "Xã Vạn Phúc", "Xã Vĩnh Quỳnh", "Xã Yên Mỹ"],
      "Sóc Sơn": ["Thị trấn Sóc Sơn", "Xã Bắc Phú", "Xã Bắc Sơn", "Xã Đông Xuân", "Xã Hiền Ninh", "Xã Hồng Kỳ", "Xã Kim Lũ", "Xã Mai Đình", "Xã Nam Sơn", "Xã Phú Cường", "Xã Phù Linh", "Xã Phù Lỗ", "Xã Quang Tiến", "Xã Tân Dân", "Xã Tân Hưng", "Xã Tân Minh", "Xã Thanh Xuân", "Xã Tiên Dược", "Xã Trung Giã", "Xã Việt Long", "Xã Xuân Giang", "Xã Xuân Thu"],
      "Hoài Đức": ["Thị trấn Trạm Trôi", "Xã An Khánh", "Xã An Thượng", "Xã Cát Quế", "Xã Đắc Sở", "Xã Di Trạch", "Xã Đông La", "Xã Đức Giang", "Xã Đức Thượng", "Xã Kim Chung", "Xã La Phù", "Xã Lại Yên", "Xã Song Phương", "Xã Tiền Yên", "Xã Vân Canh", "Xã Vân Côn", "Xã Yên Sở"]
    }
  },
  "Đà Nẵng": {
    name: "Đà Nẵng",
    aliases: ["Da Nang", "TP Đà Nẵng"],
    districts: {
      "Hải Châu": ["Phường Hải Châu 1", "Phường Hải Châu 2", "Phường Thạch Thang", "Phường Thanh Bình", "Phường Thuận Phước", "Phường Hòa Thuận Tây", "Phường Hòa Thuận Đông", "Phường Nam Dương", "Phường Phước Ninh", "Phường Bình Thuận", "Phường Bình Hiên", "Phường Hòa Cường Bắc", "Phường Hòa Cường Nam"],
      "Thanh Khê": ["Phường Tam Thuận", "Phường Thanh Khê Tây", "Phường Thanh Khê Đông", "Phường Xuân Hà", "Phường Tân Chính", "Phường Chính Gián", "Phường Vĩnh Trung", "Phường Thạc Gián", "Phường An Khê", "Phường Hòa Khê"],
      "Sơn Trà": ["Phường Thọ Quang", "Phường Nại Hiên Đông", "Phường Mân Thái", "Phường An Hải Bắc", "Phường Phước Mỹ", "Phường An Hải Tây", "Phường An Hải Đông"],
      "Ngũ Hành Sơn": ["Phường Mỹ An", "Phường Khuê Mỹ", "Phường Hòa Quý", "Phường Hòa Hải"],
      "Liên Chiểu": ["Phường Hòa Hiệp Bắc", "Phường Hòa Hiệp Nam", "Phường Hòa Khánh Bắc", "Phường Hòa Khánh Nam", "Phường Hòa Minh"],
      "Cẩm Lệ": ["Phường Khuê Trung", "Phường Hòa Phát", "Phường Hòa An", "Phường Hòa Thọ Tây", "Phường Hòa Thọ Đông", "Phường Hòa Xuân"],
      "Hòa Vang": ["Xã Hòa Bắc", "Xã Hòa Liên", "Xã Hòa Ninh", "Xã Hòa Sơn", "Xã Hòa Nhơn", "Xã Hòa Phú", "Xã Hòa Phong", "Xã Hòa Châu", "Xã Hòa Tiến", "Xã Hòa Phước", "Xã Hòa Khương"]
    }
  },
  "Bình Dương": {
    name: "Bình Dương",
    aliases: ["Binh Duong"],
    districts: {
      "TP Thủ Dầu Một": ["Phường Phú Cường", "Phường Hiệp Thành", "Phường Chánh Nghĩa", "Phường Phú Thọ", "Phường Phú Hòa", "Phường Phú Lợi", "Phường Phú Mỹ", "Phường Định Hòa", "Phường Hiệp An", "Phường Phú Tân", "Phường Hòa Phú", "Phường Tân An", "Phường Tương Bình Hiệp", "Phường Chánh Mỹ"],
      "TP Dĩ An": ["Phường Dĩ An", "Phường An Bình", "Phường Tân Đông Hiệp", "Phường Đông Hòa", "Phường Tân Bình", "Phường Bình An", "Phường Bình Thắng"],
      "TP Thuận An": ["Phường Lái Thiêu", "Phường An Thạnh", "Phường Vĩnh Phú", "Phường Bình Hòa", "Phường Thuận Giao", "Phường An Phú", "Phường Bình Chuẩn", "Phường Hưng Định", "Phường Bình Nhâm", "Xã An Sơn"],
      "TP Tân Uyên": ["Phường Uyên Hưng", "Phường Tân Phước Khánh", "Phường Thái Hòa", "Phường Thạnh Phước", "Phường Tân Hiệp", "Phường Khánh Bình", "Phường Hội Nghĩa", "Phường Vĩnh Tân", "Phường Phú Chánh", "Phường Tân Vĩnh Hiệp", "Xã Bạch Đằng", "Xã Thạnh Hội"],
      "Bến Cát": ["Phường Mỹ Phước", "Phường Thới Hòa", "Phường Tân Định", "Phường Hòa Lợi", "Phường Chánh Phú Hòa", "Xã An Điền", "Xã An Tây", "Xã Phú An"],
      "Bàu Bàng": ["Thị trấn Lai Uyên", "Xã Cây Trường II", "Xã Hưng Hòa", "Xã Lai Hưng", "Xã Long Nguyên", "Xã Tân Hưng", "Xã Trừ Văn Thố"]
    }
  },
  "Đồng Nai": {
    name: "Đồng Nai",
    aliases: ["Dong Nai"],
    districts: {
      "TP Biên Hòa": ["Phường Trung Dũng", "Phường Thanh Bình", "Phường Quyết Thắng", "Phường Quang Vinh", "Phường Hòa Bình", "Phường Bửu Long", "Phường Tân Hạnh", "Phường Tân Vạn", "Phường Bửu Hòa", "Phường Hóa An", "Phường Hiệp Hòa", "Phường Tân Tiến", "Phường Tân Mai", "Phường Thống Nhất", "Phường Trảng Dài", "Phường Tân Phong", "Phường Hố Nai", "Phường Tân Biên", "Phường Tân Hòa", "Phường Long Bình", "Phường Long Bình Tân", "Phường Tam Hiệp", "Phường Bình Đa", "Phường An Bình", "Phường Tam Hòa", "Phường Phước Tân", "Phường Tam Phước", "Phường An Hòa", "Xã Long Hưng"],
      "TP Long Khánh": ["Phường Xuân Trung", "Phường Xuân Thanh", "Phường Xuân An", "Phường Xuân Bình", "Phường Xuân Hòa", "Phường Phú Bình", "Phường Suối Tre", "Phường Bảo Vinh", "Phường Bàu Sen", "Phường Bàu Trâm", "Xã Bình Lộc", "Xã Bảo Quang", "Xã Hàng Gòn", "Xã Cẩm Đường"],
      "Long Thành": ["Thị trấn Long Thành", "Xã An Phước", "Xã Bàu Cạn", "Xã Bình An", "Xã Bình Sơn", "Xã Cẩm Đường", "Xã Lộc An", "Xã Long An", "Xã Long Đức", "Xã Long Phước", "Xã Phước Bình", "Xã Phước Thái", "Xã Tam An", "Xã Tân Hiệp"],
      "Nhơn Trạch": ["Thị trấn Hiệp Phước", "Xã Đại Phước", "Xã Long Tân", "Xã Long Thọ", "Xã Phú Đông", "Xã Phú Hội", "Xã Phú Hữu", "Xã Phú Thạnh", "Xã Phước An", "Xã Phước Khánh", "Xã Phước Thiền", "Xã Vĩnh Thanh"]
    }
  },
  "Hải Phòng": {
    name: "Hải Phòng",
    aliases: ["Hai Phong", "TP Hải Phòng"],
    districts: {
      "Hồng Bàng": ["Phường Hoàng Văn Thụ", "Phường Minh Khai", "Phường Phan Bội Châu", "Phường Sở Dầu", "Phường Thượng Lý", "Phường Trại Chuối", "Phường Quán Toan", "Phường Hùng Vương", "Phường An Hưng"],
      "Ngô Quyền": ["Phường Cầu Đất", "Phường Cầu Tre", "Phường Đằng Giang", "Phường Đông Khê", "Phường Đồng Quốc Bình", "Phường Gia Viên", "Phường Lạc Viên", "Phường Lạch Tray", "Phường Lê Lợi", "Phường Máy Chai", "Phường Máy Tơ", "Phường Vạn Mỹ"],
      "Lê Chân": ["Phường An Biên", "Phường An Dương", "Phường Cát Dài", "Phường Đông Hải", "Phường Dư Hàng", "Phường Dư Hàng Kênh", "Phường Hàng Kênh", "Phường Hồ Nam", "Phường Kênh Dương", "Phường Lam Sơn", "Phường Niệm Nghĩa", "Phường Nghĩa Xá", "Phường Trại Cau", "Phường Trần Nguyên Hãn", "Phường Vĩnh Niệm"],
      "Hải An": ["Phường Cát Bi", "Phường Đằng Hải", "Phường Đằng Lâm", "Phường Đông Hải 1", "Phường Đông Hải 2", "Phường Nam Hải", "Phường Thành Tô", "Phường Tràng Cát"],
      "Kiến An": ["Phường Bắc Sơn", "Phường Đồng Hòa", "Phường Nam Sơn", "Phường Ngọc Sơn", "Phường Phù Liễn", "Phường Quán Trữ", "Phường Trần Thành Ngọ", "Phường Văn Đẩu"]
    }
  },
  "Cần Thơ": {
    name: "Cần Thơ",
    aliases: ["Can Tho", "TP Cần Thơ"],
    districts: {
      "Ninh Kiều": ["Phường Cái Khế", "Phường An Hòa", "Phường Thới Bình", "Phường An Nghiệp", "Phường An Cư", "Phường Tân An", "Phường An Phú", "Phường Xuân Khánh", "Phường Hưng Lợi", "Phường An Khánh", "Phường An Bình"],
      "Bình Thủy": ["Phường Bình Thủy", "Phường Trà An", "Phường Trà Nóc", "Phường Thới An Đông", "Phường Bùi Hữu Nghĩa", "Phường Long Hòa", "Phường Long Tuyền", "Phường An Thới"],
      "Cái Răng": ["Phường Lê Bình", "Phường Hưng Phú", "Phường Hưng Thạnh", "Phường Ba Láng", "Phường Phú Thứ", "Phường Tân Phú", "Phường Đông Thuận"]
    }
  },
  "An Giang": { name: "An Giang", districts: { "TP Long Xuyên": [], "TP Châu Đốc": [], "Chợ Mới": [], "Phú Tân": [] } },
  "Bà Rịa - Vũng Tàu": { name: "Bà Rịa - Vũng Tàu", aliases: ["Vũng Tàu"], districts: { "TP Vũng Tàu": [], "TP Bà Rịa": [], "Thị xã Phú Mỹ": [], "Long Điền": [] } },
  "Bắc Giang": { name: "Bắc Giang", districts: { "TP Bắc Giang": [], "Việt Yên": [], "Hiệp Hòa": [], "Lục Ngạn": [] } },
  "Bắc Kạn": { name: "Bắc Kạn", districts: { "TP Bắc Kạn": [], "Ba Bể": [], "Chợ Đồn": [] } },
  "Bạc Liêu": { name: "Bạc Liêu", districts: { "TP Bạc Liêu": [], "Giá Rai": [], "Hòa Bình": [] } },
  "Bắc Ninh": { name: "Bắc Ninh", districts: { "TP Bắc Ninh": [], "Từ Sơn": [], "Yên Phong": [], "Quế Võ": [], "Thuận Thành": [] } },
  "Bến Tre": { name: "Bến Tre", districts: { "TP Bến Tre": [], "Châu Thành": [], "Chợ Lách": [], "Mỏ Cày Bắc": [] } },
  "Bình Định": { name: "Bình Định", aliases: ["Quy Nhơn"], districts: { "TP Quy Nhơn": [], "An Nhơn": [], "Hoài Nhơn": [] } },
  "Bình Phước": { name: "Bình Phước", districts: { "TP Đồng Xoài": [], "Chơn Thành": [], "Bình Long": [] } },
  "Bình Thuận": { name: "Bình Thuận", aliases: ["Phan Thiết"], districts: { "TP Phan Thiết": [], "La Gi": [], "Hàm Thuận Nam": [] } },
  "Cà Mau": { name: "Cà Mau", districts: { "TP Cà Mau": [], "Năm Căn": [], "Đầm Dơi": [] } },
  "Cao Bằng": { name: "Cao Bằng", districts: { "TP Cao Bằng": [], "Trùng Khánh": [], "Hòa An": [] } },
  "Đắk Lắk": { name: "Đắk Lắk", aliases: ["Buôn Ma Thuột", "Đắc Lắc"], districts: { "TP Buôn Ma Thuột": [], "Thị xã Buôn Hồ": [], "Cư M'gar": [] } },
  "Đắk Nông": { name: "Đắk Nông", districts: { "TP Gia Nghĩa": [], "Đắk Mil": [] } },
  "Điện Biên": { name: "Điện Biên", districts: { "TP Điện Biên Phủ": [], "Mường Chà": [] } },
  "Đồng Tháp": { name: "Đồng Tháp", aliases: ["Cao Lãnh"], districts: { "TP Cao Lãnh": [], "TP Sa Đéc": [], "Hồng Ngự": [] } },
  "Gia Lai": { name: "Gia Lai", aliases: ["Pleiku"], districts: { "TP Pleiku": [], "An Khê": [], "Ayun Pa": [] } },
  "Hà Giang": { name: "Hà Giang", districts: { "TP Hà Giang": [], "Đồng Văn": [], "Mèo Vạc": [] } },
  "Hà Nam": { name: "Hà Nam", aliases: ["Phủ Lý"], districts: { "TP Phủ Lý": [], "Duy Tiên": [], "Kim Bảng": [] } },
  "Hà Tĩnh": { name: "Hà Tĩnh", districts: { "TP Hà Tĩnh": [], "Hồng Lĩnh": [], "Kỳ Anh": [] } },
  "Hải Dương": { name: "Hải Dương", districts: { "TP Hải Dương": [], "Chí Linh": [], "Kinh Môn": [] } },
  "Hậu Giang": { name: "Hậu Giang", districts: { "TP Vị Thanh": [], "Ngã Bảy": [], "Châu Thành": [] } },
  "Hòa Bình": { name: "Hòa Bình", districts: { "TP Hòa Bình": [], "Lương Sơn": [], "Mai Châu": [] } },
  "Hưng Yên": { name: "Hưng Yên", districts: { "TP Hưng Yên": [], "Mỹ Hào": [], "Văn Giang": [], "Yên Mỹ": [] } },
  "Khánh Hòa": { name: "Khánh Hòa", aliases: ["Nha Trang", "Cam Ranh"], districts: { "TP Nha Trang": [], "TP Cam Ranh": [], "Ninh Hòa": [] } },
  "Kiên Giang": { name: "Kiên Giang", aliases: ["Rạch Giá", "Phú Quốc"], districts: { "TP Rạch Giá": [], "TP Phú Quốc": [], "Hà Tiên": [] } },
  "Kon Tum": { name: "Kon Tum", districts: { "TP Kon Tum": [], "Đắk Hà": [] } },
  "Lai Châu": { name: "Lai Châu", districts: { "TP Lai Châu": [], "Tam Đường": [] } },
  "Lâm Đồng": { name: "Lâm Đồng", aliases: ["Đà Lạt", "Bảo Lộc"], districts: { "TP Đà Lạt": [], "TP Bảo Lộc": [], "Đức Trọng": [] } },
  "Lạng Sơn": { name: "Lạng Sơn", districts: { "TP Lạng Sơn": [], "Cao Lộc": [], "Hữu Lũng": [] } },
  "Lào Cai": { name: "Lào Cai", aliases: ["Sa Pa"], districts: { "TP Lào Cai": [], "Thị xã Sa Pa": [], "Bát Xát": [] } },
  "Long An": { name: "Long An", aliases: ["Tân An"], districts: { "TP Tân An": [], "Bến Lức": [], "Đức Hòa": [], "Cần Giuộc": [] } },
  "Nam Định": { name: "Nam Định", districts: { "TP Nam Định": [], "Giao Thủy": [], "Hải Hậu": [] } },
  "Nghệ An": { name: "Nghệ An", aliases: ["Vinh"], districts: { "TP Vinh": [], "Cửa Lò": [], "Hoàng Mai": [], "Diễn Châu": [] } },
  "Ninh Bình": { name: "Ninh Bình", districts: { "TP Ninh Bình": [], "Tam Điệp": [], "Hoa Lư": [] } },
  "Ninh Thuận": { name: "Ninh Thuận", aliases: ["Phan Rang"], districts: { "TP Phan Rang - Tháp Chàm": [], "Ninh Hải": [] } },
  "Phú Thọ": { name: "Phú Thọ", aliases: ["Việt Trì"], districts: { "TP Việt Trì": [], "Phú Thọ": [], "Lâm Thao": [] } },
  "Phú Yên": { name: "Phú Yên", aliases: ["Tuy Hòa"], districts: { "TP Tuy Hòa": [], "Sông Cầu": [], "Đông Hòa": [] } },
  "Quảng Bình": { name: "Quảng Bình", aliases: ["Đồng Hới"], districts: { "TP Đồng Hới": [], "Ba Đồn": [], "Bố Trạch": [] } },
  "Quảng Nam": { name: "Quảng Nam", aliases: ["Tam Kỳ", "Hội An"], districts: { "TP Tam Kỳ": [], "TP Hội An": [], "Điện Bàn": [] } },
  "Quảng Ngãi": { name: "Quảng Ngãi", districts: { "TP Quảng Ngãi": [], "Bình Sơn": [], "Đức Phổ": [] } },
  "Quảng Ninh": { name: "Quảng Ninh", aliases: ["Hạ Long", "Cẩm Phả", "Uông Bí", "Móng Cái"], districts: { "TP Hạ Long": [], "TP Cẩm Phả": [], "TP Uông Bí": [], "TP Móng Cái": [] } },
  "Quảng Trị": { name: "Quảng Trị", aliases: ["Đông Hà"], districts: { "TP Đông Hà": [], "Thị xã Quảng Trị": [] } },
  "Sóc Trăng": { name: "Sóc Trăng", districts: { "TP Sóc Trăng": [], "Vĩnh Châu": [], "Ngã Năm": [] } },
  "Sơn La": { name: "Sơn La", districts: { "TP Sơn La": [], "Mộc Châu": [] } },
  "Tây Ninh": { name: "Tây Ninh", districts: { "TP Tây Ninh": [], "Trảng Bàng": [], "Hòa Thành": [] } },
  "Thái Bình": { name: "Thái Bình", districts: { "TP Thái Bình": [], "Tiền Hải": [], "Hưng Hà": [] } },
  "Thái Nguyên": { name: "Thái Nguyên", districts: { "TP Thái Nguyên": [], "Sông Công": [], "Phổ Yên": [] } },
  "Thanh Hóa": { name: "Thanh Hóa", districts: { "TP Thanh Hóa": [], "Sầm Sơn": [], "Bỉm Sơn": [], "Nghi Sơn": [] } },
  "Thừa Thiên Huế": { name: "Thừa Thiên Huế", aliases: ["Huế"], districts: { "TP Huế": [], "Hương Thủy": [], "Hương Trà": [] } },
  "Tiền Giang": { name: "Tiền Giang", aliases: ["Mỹ Tho"], districts: { "TP Mỹ Tho": [], "Gò Công": [], "Cai Lậy": [] } },
  "Trà Vinh": { name: "Trà Vinh", districts: { "TP Trà Vinh": [], "Duyên Hải": [] } },
  "Tuyên Quang": { name: "Tuyên Quang", districts: { "TP Tuyên Quang": [], "Yên Sơn": [] } },
  "Vĩnh Long": { name: "Vĩnh Long", districts: { "TP Vĩnh Long": [], "Bình Minh": [], "Long Hồ": [] } },
  "Vĩnh Phúc": { name: "Vĩnh Phúc", aliases: ["Vĩnh Yên"], districts: { "TP Vĩnh Yên": [], "Phúc Yên": [], "Bình Xuyên": [] } },
  "Yên Bái": { name: "Yên Bái", districts: { "TP Yên Bái": [], "Nghĩa Lộ": [] } }
}

export const POPULAR_PROVINCES = [
  "Hồ Chí Minh",
  "Hà Nội",
  "Đà Nẵng",
  "Bình Dương",
  "Đồng Nai",
  "Hải Phòng",
  "Cần Thơ"
]

export function removeVietnameseAccents(str: string): string {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase()
    .trim()
}

/**
 * Chuẩn hóa tên đơn vị hành chính để so khớp (P. -> Phường, Q. -> Quận, v.v.)
 */
export function normalizeAdminPrefix(str: string): string {
  let s = str.trim()
  s = s.replace(/^p\.\s*/i, "Phường ")
  s = s.replace(/^q\.\s*/i, "Quận ")
  s = s.replace(/^h\.\s*/i, "Huyện ")
  s = s.replace(/^tx\.\s*/i, "Thị xã ")
  s = s.replace(/^tp\.\s*/i, "TP ")
  s = s.replace(/^tt\.\s*/i, "Thị trấn ")
  return s
}

/**
 * Tìm Tỉnh/Thành phố khớp nhất từ tên hoặc alias
 */
export function matchProvince(text: string): string | null {
  if (!text) return null
  const clean = text.trim()
  const norm = removeVietnameseAccents(clean)

  for (const [pName, info] of Object.entries(VIETNAM_PROVINCES)) {
    if (clean.toLowerCase() === pName.toLowerCase() || norm === removeVietnameseAccents(pName)) {
      return pName
    }
    if (info.aliases) {
      for (const alias of info.aliases) {
        if (clean.toLowerCase() === alias.toLowerCase() || norm === removeVietnameseAccents(alias)) {
          return pName
        }
      }
    }
  }

  // Partial match
  for (const [pName, info] of Object.entries(VIETNAM_PROVINCES)) {
    if (norm.includes(removeVietnameseAccents(pName))) {
      return pName
    }
    if (info.aliases) {
      for (const alias of info.aliases) {
        if (norm.includes(removeVietnameseAccents(alias))) {
          return pName
        }
      }
    }
  }
  return null
}

/**
 * Lấy danh sách Quận / Huyện gợi ý theo Tỉnh
 */
export function getDistricts(provinceName?: string): string[] {
  if (!provinceName) return []
  const prov = VIETNAM_PROVINCES[provinceName]
  if (!prov) return []
  return Object.keys(prov.districts)
}

/**
 * Lấy danh sách Phường / Xã gợi ý theo Tỉnh và Quận
 */
export function getWards(provinceName?: string, districtName?: string): string[] {
  if (!provinceName || !districtName) return []
  const prov = VIETNAM_PROVINCES[provinceName]
  if (!prov) return []

  // Tìm trực tiếp hoặc fuzzy match district
  let wards = prov.districts[districtName]
  if (!wards) {
    const normD = removeVietnameseAccents(districtName)
    for (const [d, w] of Object.entries(prov.districts)) {
      if (removeVietnameseAccents(d) === normD || removeVietnameseAccents(d).includes(normD) || normD.includes(removeVietnameseAccents(d))) {
        wards = w
        break
      }
    }
  }
  return wards || []
}

/**
 * Tự động bóc tách chuỗi địa chỉ tự do (Ví dụ: "456 Lê Lợi, P. Bến Thành, Q.1, TP. Hồ Chí Minh")
 */
export function parseVietnameseAddress(fullAddress: string): {
  city: string
  district: string
  ward: string
  address: string
} {
  const result = {
    city: "",
    district: "",
    ward: "",
    address: fullAddress.trim()
  }

  if (!fullAddress || fullAddress.trim().length === 0) {
    return result
  }

  // Chia theo dấu phẩy, gạch chéo, hoặc xuống dòng
  const parts = fullAddress.split(/[,;\-\n/]+/).map(p => p.trim()).filter(Boolean)
  if (parts.length === 0) return result

  let remaining = [...parts]

  // 1. Tìm Tỉnh / TP từ cuối chuỗi ngược lại
  for (let i = remaining.length - 1; i >= 0; i--) {
    const part = remaining[i]
    if (!part) continue
    const matched = matchProvince(part)
    if (matched) {
      result.city = matched
      remaining.splice(i, 1)
      break
    }
  }

  const normAll = removeVietnameseAccents(fullAddress.toLowerCase())

  // Nếu chưa tìm được Tỉnh, thử quét toàn bộ chuỗi theo tên tỉnh và alias
  if (!result.city) {
    for (const [pName, info] of Object.entries(VIETNAM_PROVINCES)) {
      if (normAll.includes(removeVietnameseAccents(pName.toLowerCase()))) {
        result.city = pName
        break
      }
      if (info.aliases) {
        for (const alias of info.aliases) {
          if (normAll.includes(removeVietnameseAccents(alias.toLowerCase()))) {
            result.city = pName
            break
          }
        }
      }
      if (result.city) break
    }
  }

  // 2. Tìm Quận / Huyện
  // 2a. Nếu đã có Tỉnh: tìm trong các quận của Tỉnh đó
  let provInfo = result.city ? VIETNAM_PROVINCES[result.city] : null
  if (provInfo && Object.keys(provInfo.districts).length > 0) {
    for (let i = remaining.length - 1; i >= 0; i--) {
      const rawPart = remaining[i]
      if (!rawPart) continue
      const part = normalizeAdminPrefix(rawPart)
      const normPart = removeVietnameseAccents(part.toLowerCase())
      for (const dName of Object.keys(provInfo.districts)) {
        const normD = removeVietnameseAccents(dName.toLowerCase())
        if (normPart === normD || normPart.includes(normD) || normD.includes(normPart)) {
          result.district = dName
          remaining.splice(i, 1)
          break
        }
      }
      if (result.district) break
    }
  }

  // 2b. Nếu CHƯA tìm ra Quận (hoặc chưa có Tỉnh): Quét tất cả quận/huyện trên 63 tỉnh
  if (!result.district) {
    for (const [pName, pInfo] of Object.entries(VIETNAM_PROVINCES)) {
      if (result.city && result.city !== pName) continue
      for (const dName of Object.keys(pInfo.districts)) {
        const normD = removeVietnameseAccents(dName.toLowerCase())
        if (normD.length >= 3 && normAll.includes(normD)) {
          result.district = dName
          if (!result.city) {
            result.city = pName
            provInfo = pInfo
          }
          break
        }
      }
      if (result.district) break
    }
  }

  // Fallback tìm Quận/Huyện theo tiền tố quận/huyện/thị xã/tp
  if (!result.district) {
    for (let i = remaining.length - 1; i >= 0; i--) {
      const rawPart = remaining[i]
      if (!rawPart) continue
      const part = normalizeAdminPrefix(rawPart)
      const normPart = removeVietnameseAccents(part)
      if (/^(quan|huyen|thi xa|tx|tp|thanh pho)\s+/i.test(normPart) || /^(q|h)\.?\s*\d+/i.test(normPart)) {
        result.district = part
        remaining.splice(i, 1)
        break
      }
    }
  }

  // 3. Tìm Phường / Xã
  // 3a. Tìm trong danh sách phường của quận đã xác định
  if (result.city && result.district) {
    const wardList = getWards(result.city, result.district)
    if (wardList.length > 0) {
      for (let i = remaining.length - 1; i >= 0; i--) {
        const rawPart = remaining[i]
        if (!rawPart) continue
        const part = normalizeAdminPrefix(rawPart)
        const normPart = removeVietnameseAccents(part.toLowerCase())
        for (const wName of wardList) {
          const normW = removeVietnameseAccents(wName.toLowerCase())
          const cleanW = removeVietnameseAccents(wName.replace(/^(phường|xã|thị trấn)\s+/i, '').toLowerCase())
          if (normPart === normW || normPart.includes(cleanW) || normAll.includes(cleanW)) {
            result.ward = wName
            remaining.splice(i, 1)
            break
          }
        }
        if (result.ward) break
      }
    }
  }

  // 3b. Quét toàn bộ danh sách phường (nếu chưa có phường hoặc cần suy ngược quận/tỉnh)
  if (!result.ward) {
    const provincesToSearch = result.city
      ? { [result.city]: VIETNAM_PROVINCES[result.city] }
      : VIETNAM_PROVINCES

    for (const [pName, pInfo] of Object.entries(provincesToSearch)) {
      if (!pInfo || !pInfo.districts) continue
      for (const [dName, wards] of Object.entries(pInfo.districts)) {
        for (const wName of wards) {
          const cleanW = removeVietnameseAccents(wName.replace(/^(phường|xã|thị trấn)\s+/i, '').toLowerCase())
          if (cleanW.length >= 3 && normAll.includes(cleanW)) {
            result.ward = wName
            if (!result.city) result.city = pName
            if (!result.district) result.district = dName
            break
          }
        }
        if (result.ward) break
      }
      if (result.ward) break
    }
  }

  // Fallback tìm Phường/Xã theo tiền tố
  if (!result.ward) {
    for (let i = remaining.length - 1; i >= 0; i--) {
      const rawPart = remaining[i]
      if (!rawPart) continue
      const part = normalizeAdminPrefix(rawPart)
      const normPart = removeVietnameseAccents(part)
      if (/^(phuong|xa|thi tran|tt)\s+/i.test(normPart) || /^p\.?\s*\d+/i.test(normPart)) {
        result.ward = part
        remaining.splice(i, 1)
        break
      }
    }
  }

  // 4. Số nhà, tên đường là phần còn lại
  let detailAddr = remaining.length > 0 ? remaining.join(", ") : fullAddress.trim()
  const tokensToRemove = [result.city, result.district, result.ward].filter(Boolean)
  for (const t of tokensToRemove) {
    const escaped = t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    detailAddr = detailAddr.replace(new RegExp(escaped, 'gi'), '').trim()
    const cleanT = t.replace(/^(Thành phố|Tỉnh|Quận|Huyện|Thị xã|Phường|Xã|Thị trấn)\s+/i, '').trim()
    if (cleanT && cleanT.length >= 3) {
      const escClean = cleanT.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      detailAddr = detailAddr.replace(new RegExp(`\\b(p\\.|q\\.|h\\.|tx\\.|tp\\.)?\\s*${escClean}\\b`, 'gi'), '').trim()
    }
  }
  detailAddr = detailAddr.replace(/[,;\-\s]+$/, '').replace(/^[,;\-\s]+/, '').replace(/\s*,\s*,+/g, ', ').trim()
  result.address = detailAddr || fullAddress.trim()

  return result
}
